import React, { useEffect, useState } from 'react';
import { ConfigProvider, Button, Col, Modal, Pagination, Row } from 'antd';
import faIR from 'antd/locale/fa_IR';
import { Delete_Food_Api, GetAll_Paging_Food_Api } from '../../API/FoodApi';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
// ======================================================================
export const AllFoodComponent = ({
    setLoading,
    showMessage,
    version,
    currentPage,
    setCurrentPage,
    isShowInsert = false,
    onAddClick,
    onEdit,
    onRowDeleted,
}) => {
    // ======================================================================
    const [foods, setFoods] = useState([]);
    const [pageCount, setPageCount] = useState(4);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, [currentPage, version]);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Paging_Food_Api({ pageNumber: currentPage, });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setPageCount(data.messageData.pageCount * 10)
                setFoods(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const deleteRow = async (id) => {
        try {
            setLoading(true);
            let data = await Delete_Food_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                onRowDeleted();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (
        <>
            <Row className='sectionTitle'>
                <Col xs={14} sm={14} md={16} lg={18} xl={18}>
                    <h2 >
                        لیست غذاها
                    </h2>
                </Col>
                <Col xs={10} sm={10} md={8} lg={6} xl={6} style={{ textAlign: "left" }}>
                    <Button className='btn-primary'
                        onClick={() => onAddClick()} >
                        <PlusOutlined />
                        ایجاد غذای جدید
                    </Button>
                </Col>
            </Row>
            <div className='container'>
                {foods.map((food, key) =>
                    <>
                        <Row key={key} className="valueRow" >
                            <Col className="valueColumn textRight" xs={12} sm={12} md={12} lg={15} xl={15} >
                                {food.title}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={9} xl={9} style={{ textAlign: "left" }}>


                                <Button className='btn-success' style={{ marginLeft: "2px" }} onClick={() => onEdit(food.id)}>
                                    <EditOutlined />
                                    ویرایش</Button>


                                <Button
                                    className='btn-danger'
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'آیا از حذف ' + food.title + ' اطمینان دارید؟',
                                            onOk: () => { deleteRow(food.id) },
                                            footer: (_, { OkBtn, CancelBtn }) => (
                                                <>
                                                    <CancelBtn />
                                                    <OkBtn />
                                                </>
                                            ),
                                        });
                                    }}
                                >
                                    <DeleteOutlined />
                                    حذف</Button>


                            </Col>
                        </Row>
                    </>
                )}
            </div>
            <ConfigProvider direction="rtl" locale={faIR}>
                <Pagination current={currentPage}
                    showSizeChanger={false}
                    showQuickJumper={false}
                    align="center" onChange={(page) => setCurrentPage(page)} total={pageCount} />
            </ConfigProvider>
        </>
    )
}